export const UPDATE_FK_RATING_FAILURE = 'UPDATE_FK_RATING_FAILURE';

export const updateFkRatingFailure = error => ({
    type: UPDATE_FK_RATING_FAILURE,
    payload: error,
    error: true,
});
